import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { translateFormFieldLabel } from '../../../../../helpers/collaborativeIndexations'
import { isEmpty } from '../../../../../helpers/sanityChecks'

class BirthDateLabel extends Component
{
    static propTypes = {
        t: PropTypes.func.isRequired,
        field: PropTypes.string.isRequired,
        value: PropTypes.object,
    }

    constructor(props)
    {
        super(props)

        this.translateField = this.translateField.bind(this)
        this.computeTranslationKey = this.computeTranslationKey.bind(this)
    }

    translateField(fieldName)
    {
        return translateFormFieldLabel(this.props.t, fieldName)
    }

    computeTranslationKey()
    {
        if(this.props.value === null || this.props.value.parts === undefined)
        {
            return 'incompleteBirthDate.empty'
        }

        const dateParts = this.props.value.parts

        if(! isEmpty(dateParts.day) && ! isEmpty(dateParts.month) && ! isEmpty(dateParts.year))
        {
            return 'birthDate'
        }

        if(! isEmpty(dateParts.month) && ! isEmpty(dateParts.year))
        {
            return 'incompleteBirthDate.monthYear'
        }

        return 'incompleteBirthDate.year'
    }

    render()
    {
        const label = this.translateField(this.computeTranslationKey())

        return (
            <label title={label}>{label}</label>
        )
    }
}

export default withTranslation()(BirthDateLabel)
